const tooltipFormParamEquipModel = {
  title: 'clone equipment type'
};

export default tooltipFormParamEquipModel;
